import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Link } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import ToggleLinkMenu from './ToggleLinkMenu';

const HeaderMenu = (props) => {
  const location = useLocation();
  const history = useHistory();

  const [isToolsActive, setIsToolsActive] = useState(false);
  const toggleToolsDropdown = () => setIsToolsActive(!isToolsActive);
  const forceToolsDropdownState = (state) => setIsToolsActive(state);


  const [isAccountActive, setIsAccountActive] = useState(false);
  const toggleAccountDropdown = () => setIsAccountActive(!isAccountActive);
  const forceAccountDropdownState = (state) => setIsAccountActive(state);


  const [isWorkflowsActive, setIsWorkflowsActive] = useState(false);
  const toggleWorkflowsDropdown = () => setIsWorkflowsActive(!isWorkflowsActive);
  const forceWorkflowsDropdownState = (state) => setIsWorkflowsActive(state);

  const [toggle, setToggle] = useState()

  const toggleMenu = () => {
    setToggle(!toggle)
  }

  const getMenuClassName = (path, path2, pathOptions) => {
    if (pathOptions != undefined) {
      for (const option of pathOptions) {
        if (location.pathname === option || location.pathname.startsWith(option + "/")) {
          return "nav-link nav-link-active"
        }
      }
    }

    if (location.pathname === path || location.pathname.startsWith(path + "/") || location.pathname === path2 || location.pathname.startsWith(path2 + "/")) {
      return "nav-link nav-link-active"
    } else {
      return "nav-link"
    }
  }

  const noDropdownsShouldBeOpen = () => {
    forceAccountDropdownState(false)
    forceToolsDropdownState(false)
    forceWorkflowsDropdownState(false)
  }

  const openMineAndCloseDownOthers = (mine, eventType) => {
    if (isAccountActive) {
      forceAccountDropdownState(false)
    }

    if (isToolsActive) {
      forceToolsDropdownState(false)
    }

    if (isWorkflowsActive) {
      forceWorkflowsDropdownState(false)
    }

    switch (mine) {
      case 'account':
        toggleAccountDropdown()
        break;
      case 'tools':
        toggleToolsDropdown()
        break;
      case 'workflows':
        toggleWorkflowsDropdown()
        break;
      default:
        break;
    }
  }

  // style="min-height: 101px;" 
  return (
    <header id="header-section" className="header active-three">
      <div className="d-lg-none">
        <div className="d-flex container" style={{ padding: props.isLegacy ? "initial" : "16px" }}>
          <div className="mobile-logo mr-auto">
            {props.isLegacy ?
              <div className="logo" style={{ paddingTop: '8px' }}>
                <a href="https://simplyflows.com" className="custom-logo-link" rel="home"><img width="300" src="https://simplyflows.com/wp-content/uploads/2020/10/Simply-Flows-Logo-Full-2.png" alt="Simply Flows Logo" loading="lazy" /></a>
              </div> :
              <div className="logo" style={{ paddingTop: '8px' }}>
                <a href="https://simplyflows.com" className="custom-logo-link" rel="home"><img width="200" src="https://simplyflows.com/wp-content/uploads/2020/10/Simply-Flows-Logo-Full-2.png" alt="Simply Flows Logo" loading="lazy" /></a>
              </div>
            }
          </div>
          {/* <div className="custom-control custom-switch" style={{ marginLeft: '16px', paddingTop: '8px', marginRight: '8px' }}>
            <input type="checkbox" className="custom-control-input" id="legacy-switch" onClick={props.toggleLegacy} checked={props.isLegacy}></input>
            <label className="custom-control-label" htmlFor="legacy-switch">Legacy</label>
          </div> */}
          <button type="button" className="hamburger-menu" onClick={toggleMenu}>
            <i className="fas fa-bars"></i>
          </button>
          <Modal show={toggle}  >
            <Modal.Header className="d-flex">
              {props.isLegacy ?
                <div className="logo mr-auto" style={{ paddingTop: '8px' }}>
                  <a href="https://simplyflows.com" className="custom-logo-link" rel="home"><img width="300" src="https://simplyflows.com/wp-content/uploads/2020/10/Simply-Flows-Logo-Full-2.png" alt="Simply Flows Logo" loading="lazy" /></a>
                </div> :
                <div className="logo mr-auto" style={{ paddingTop: '8px' }}>
                  <a href="https://simplyflows.com" className="custom-logo-link" rel="home"><img width="200" src="https://simplyflows.com/wp-content/uploads/2020/10/Simply-Flows-Logo-Full-2.png" alt="Simply Flows Logo" loading="lazy" /></a>
                </div>
              }
              <button type="button" className="hamburger-menu" onClick={toggleMenu}><i className="fas fa-times"></i></button>
            </Modal.Header>
            <Modal.Body>
              <ul id="menu-primary" className="menu-wrap">
                <Link to="/myapps" className="nav-link-mobile" onClick={toggleMenu}>My Apps</Link>

                {/* <Link to="/create" className="nav-link-mobile" onClick={toggleMenu}>Create Workflow</Link>
                <Link to="/workflows" className="nav-link-mobile" onClick={toggleMenu}>My Workflows</Link>
                 */}

                {props.isLegacy ? <Link to="/create" className="nav-link-mobile" onClick={toggleMenu}>Create Workflow</Link> : null}
                {props.isLegacy ? <Link to="/workflows" className="nav-link-mobile" onClick={toggleMenu}>My Workflows</Link> : null}
                {props.isLegacy ? <Link to="/templates" className="nav-link-mobile" onClick={toggleMenu}>Templates</Link> : null}

                {props.isLegacy ? null : <Link to="#" className="nav-link-mobile" onClick={() => { toggleMenu(); toggleWorkflowsDropdown() }}>Workflows</Link>}
                {props.isLegacy ? null : <Link style={{ display: isWorkflowsActive ? 'flex' : 'none', marginLeft: 10 }} to="/create" className="nav-link-mobile" onClick={() => { toggleMenu(); toggleWorkflowsDropdown() }}>Create Workflow</Link>}
                {props.isLegacy ? null : <Link style={{ display: isWorkflowsActive ? 'flex' : 'none', marginLeft: 10 }} to="/workflows" className="nav-link-mobile" onClick={() => { toggleMenu(); toggleWorkflowsDropdown() }}>My Workflows</Link>}

                <Link to="/templates" className="nav-link-mobile" onClick={toggleMenu}>Templates</Link>

                <Link to="#" className="nav-link-mobile" onClick={toggleToolsDropdown}>Free Tools</Link>
                <Link style={{ display: isToolsActive ? 'flex' : 'none', marginLeft: 10 }} to="/tools/crypto-activity-tracker" className="nav-link-mobile" onClick={() => { toggleMenu(); toggleToolsDropdown() }}>Crypto Activity Tracker</Link>
                <Link style={{ display: isToolsActive ? 'flex' : 'none', marginLeft: 10 }} to="/tools/crypto-range-tracker" className="nav-link-mobile" onClick={() => { toggleMenu(); toggleToolsDropdown() }}>Crypto Range Tracker</Link>
                <Link style={{ display: isToolsActive ? 'flex' : 'none', marginLeft: 10 }} to="/tools/commute-calculator" className="nav-link-mobile" onClick={() => { toggleMenu(); toggleToolsDropdown() }}>Calc. Commute</Link>

                <Link to="/search" className="nav-link-mobile" onClick={toggleMenu}>Search</Link>
                <Link to="/user/profile" className="nav-link-mobile" onClick={toggleMenu}>My Profile</Link>
                <Link to="/user/rewards" className="nav-link-mobile" onClick={toggleMenu}>Rewards</Link>
                <Link to="/user/signout" className="nav-link-mobile" onClick={toggleMenu}>Sign out</Link>
              </ul>
            </Modal.Body>
          </Modal>
        </div>
      </div>
      <div className="d-none d-lg-block menu-large">
        <div className="d-flex container">
          {props.isLegacy ?
            <div style={{ paddingTop: '8px' }}>
              <a href="https://simplyflows.com" className="custom-logo-link" rel="home"><img width="200" src="https://simplyflows.com/wp-content/uploads/2020/10/Simply-Flows-Logo-Full-2.png" alt="Simply Flows Logo" loading="lazy" /></a>
            </div> :
            <div style={{ paddingTop: '8px' }}>
              <a href="https://simplyflows.com" className="custom-logo-link" rel="home"><img width="200" src="https://simplyflows.com/wp-content/uploads/2020/10/Simply-Flows-Logo-Full-2.png" alt="Simply Flows Logo" loading="lazy" /></a>
            </div>
          }

          {/* <div className="custom-control custom-switch" style={{ marginLeft: '16px', paddingTop: '8px' }}>
            <input type="checkbox" className="custom-control-input" id="legacy-switch" onClick={props.toggleLegacy} checked={props.isLegacy}></input>
            <label className="custom-control-label" htmlFor="legacy-switch">Legacy</label>
          </div> */}

          <div className="col-lg-9 my-auto d-flex">
            <Link to="/myapps" className={getMenuClassName("/myapps")} onMouseEnter={noDropdownsShouldBeOpen}>My Apps</Link>

            {props.isLegacy ? <Link to="/create" className={getMenuClassName("/create", "/workflow")} onMouseEnter={noDropdownsShouldBeOpen}>Create Workflow</Link> : null}
            {props.isLegacy ? <Link to="/workflows" className={getMenuClassName("/workflows")} onMouseEnter={noDropdownsShouldBeOpen}>My Workflows</Link> : null}
            {props.isLegacy ? null :
              <ToggleLinkMenu
                title={"Workflows"}
                isActive={isWorkflowsActive}
                className={getMenuClassName(null, null, ["/create", "/workflow", "/workflows"])}
                toggleEvent={(eventType) => openMineAndCloseDownOthers('workflows', eventType)}
                mainMenuOnClick={() => {history.push("/workflows")}}
                links={[
                  <Link to="/create" className={getMenuClassName("/create", "/workflow")}>Create Workflow</Link>,
                  <Link to="/workflows" className={getMenuClassName("/workflows")}>My Workflows</Link>
                ]}
              />
            }
            <Link to="/templates" className={getMenuClassName("/templates")} onMouseEnter={noDropdownsShouldBeOpen}>Templates</Link>
            {/* 
            <Link to="/create" className={getMenuClassName("/create", "/workflow")} onMouseEnter={noDropdownsShouldBeOpen}>Create Workflow</Link>
            <Link to="/workflows" className={getMenuClassName("/workflows")} onMouseEnter={noDropdownsShouldBeOpen}>My Workflows</Link>
             */}

            <ToggleLinkMenu
              title={"Free Tools"}
              isActive={isToolsActive}
              className={getMenuClassName("/tools")}
              toggleEvent={(eventType) => openMineAndCloseDownOthers('tools', eventType)}
              links={[
                <Link to="/tools/crypto-activity-tracker" className={getMenuClassName("/tools/crypto-activity-tracker")}>Crypto Activity Tracker</Link>,
                <Link to="/tools/crypto-range-tracker" className={getMenuClassName("/tools/crypto-range-tracker")}>Crypto Range Tracker</Link>,
                <Link to="/tools/commute-calculator" className={getMenuClassName("/tools/commute-calculator")}>Calc. Commute</Link>
              ]}
            />

            <Link to="/search" className={getMenuClassName("/search")} onMouseEnter={noDropdownsShouldBeOpen}>Search</Link>
            {/* <ToggleLinkMenu
              title={"Account"}
              isActive={isAccountActive}
              className={getMenuClassName("/user")}
              toggleEvent={(eventType) => openMineAndCloseDownOthers('account', eventType)}
              links={[                
                <Link to="/user/profile" className={getMenuClassName("/user/profile")} onMouseEnter={noDropdownsShouldBeOpen}>My Profile</Link>,
                <Link to="/user/rewards" className={getMenuClassName("/user/profile")} onMouseEnter={noDropdownsShouldBeOpen}>Rewards</Link>
              ]}
            /> */}


            <Link to="/user/profile" className={getMenuClassName("/user/profile")} onMouseEnter={noDropdownsShouldBeOpen}>My Profile</Link>
            {(props.rewards && props.rewards.balance && props.rewards.balance.balance >= 0)
              ? <a href="/user/rewards"><div style={{ textAlign: "center", color: "#4e1c84" }}><i className="far fa-clock" style={{ display: "inline" }}></i>&nbsp;{props.rewards.balance.balance}<br />$TIME</div></a>
              : ""}


            <div className="col-lg-9 my-auto d-flex">

            </div>
          </div>
        </div>
      </div></header >
  )
}

//style="max-width: 200px;"
export default HeaderMenu